module.exports = __webpack_public_path__ + "resources/icon_32_applaud.72dad8e878b2ddca.png";


//////////////////
// WEBPACK FOOTER
// ../src/ui/icon/img/icon_32_applaud.png
// module id = 418
// module chunks = 0 1 2 3 4